import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateDataFlowColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

import ScheduleScanButton from "../ScheduleScanButton";

type ScansEmptyStateProps = {
  hasNoResults?: boolean;
  scheduleDisabled?: boolean;
};

const ScansEmptyState = ({ hasNoResults, scheduleDisabled }: ScansEmptyStateProps) => {
  if (hasNoResults) {
    return (
      <EmptyState
        title="No results"
        caption="Don't give up! Check the spelling or try something less specific."
        icon={EmptystateSearchNoResultsColored}
        fullHeight
        announce
      />
    );
  }

  return (
    <EmptyState
      title="No scans scheduled"
      caption="Configure infrastructure scanning to detect resources outside of Spacelift's management and start bringing them under control."
      icon={EmptystateDataFlowColored}
      fullHeight
      announce
    >
      <Box gap="large">
        <ScheduleScanButton disabled={scheduleDisabled} />
        <DocumentationButton
          to={getDocsUrl("/concepts/resources#account-level-resources")}
          label="Documentation"
        />
      </Box>
    </EmptyState>
  );
};

export default ScansEmptyState;
